import { PAYMENT_ACTION_TYPES } from '../actions/types';

const initialState = {
  // Razorpay Payment Settings
  razorpaySettings: [],
  razorpayLoading: false,
  razorpayError: null,
  
  // CCAvenue Settings
  ccavenueSettings: [],
  ccavenueLoading: false,
  ccavenueError: null,
  
  // Cashfree Payment Settings
  cashfreeSettings: [],
  cashfreeLoading: false,
  cashfreeError: null,

  // Cashfree Payout Settings
  cashfreePayoutSettings: [],
  cashfreePayoutLoading: false,
  cashfreePayoutError: null,

  // Razorpay Payout Settings
  razorpayPayoutSettings: [],
  razorpayPayoutLoading: false,
  razorpayPayoutError: null,
};

const paymentReducer = (state = initialState, action) => {
  switch (action.type) {
    // ==================== RAZORPAY PAYMENT CASES ====================
    case PAYMENT_ACTION_TYPES.CREATE_RAZORPAY_SETTING_REQUEST:
    case PAYMENT_ACTION_TYPES.GET_RAZORPAY_SETTINGS_REQUEST:
    case PAYMENT_ACTION_TYPES.UPDATE_RAZORPAY_SETTING_REQUEST:
      return {
        ...state,
        razorpayLoading: true,
        razorpayError: null,
      };

    case PAYMENT_ACTION_TYPES.CREATE_RAZORPAY_SETTING_SUCCESS:
      return {
        ...state,
        razorpayLoading: false,
        razorpaySettings: [...state.razorpaySettings, action.payload],
      };

    case PAYMENT_ACTION_TYPES.GET_RAZORPAY_SETTINGS_SUCCESS:
      return {
        ...state,
        razorpayLoading: false,
        razorpaySettings: action.payload,
      };

    case PAYMENT_ACTION_TYPES.UPDATE_RAZORPAY_SETTING_SUCCESS:
      return {
        ...state,
        razorpayLoading: false,
        razorpaySettings: state.razorpaySettings.map(setting =>
          setting.id === action.payload.id ? action.payload : setting
        ),
      };

    case PAYMENT_ACTION_TYPES.CREATE_RAZORPAY_SETTING_FAIL:
    case PAYMENT_ACTION_TYPES.GET_RAZORPAY_SETTINGS_FAIL:
    case PAYMENT_ACTION_TYPES.UPDATE_RAZORPAY_SETTING_FAIL:
      return {
        ...state,
        razorpayLoading: false,
        razorpayError: action.payload,
      };

    // ==================== CCAVENUE CASES ====================
    case PAYMENT_ACTION_TYPES.CREATE_CCAVENUE_SETTING_REQUEST:
    case PAYMENT_ACTION_TYPES.GET_CCAVENUE_SETTINGS_REQUEST:
    case PAYMENT_ACTION_TYPES.UPDATE_CCAVENUE_SETTING_REQUEST:
      return {
        ...state,
        ccavenueLoading: true,
        ccavenueError: null,
      };

    case PAYMENT_ACTION_TYPES.CREATE_CCAVENUE_SETTING_SUCCESS:
      return {
        ...state,
        ccavenueLoading: false,
        ccavenueSettings: [...state.ccavenueSettings, action.payload],
      };

    case PAYMENT_ACTION_TYPES.GET_CCAVENUE_SETTINGS_SUCCESS:
      return {
        ...state,
        ccavenueLoading: false,
        ccavenueSettings: action.payload,
      };

    case PAYMENT_ACTION_TYPES.UPDATE_CCAVENUE_SETTING_SUCCESS:
      return {
        ...state,
        ccavenueLoading: false,
        ccavenueSettings: state.ccavenueSettings.map(setting =>
          setting.id === action.payload.id ? action.payload : setting
        ),
      };

    case PAYMENT_ACTION_TYPES.CREATE_CCAVENUE_SETTING_FAIL:
    case PAYMENT_ACTION_TYPES.GET_CCAVENUE_SETTINGS_FAIL:
    case PAYMENT_ACTION_TYPES.UPDATE_CCAVENUE_SETTING_FAIL:
      return {
        ...state,
        ccavenueLoading: false,
        ccavenueError: action.payload,
      };

    // ==================== CASHFREE PAYMENT CASES ====================
    case PAYMENT_ACTION_TYPES.CREATE_CASHFREE_SETTING_REQUEST:
    case PAYMENT_ACTION_TYPES.GET_CASHFREE_SETTINGS_REQUEST:
    case PAYMENT_ACTION_TYPES.UPDATE_CASHFREE_SETTING_REQUEST:
      return {
        ...state,
        cashfreeLoading: true,
        cashfreeError: null,
      };

    case PAYMENT_ACTION_TYPES.CREATE_CASHFREE_SETTING_SUCCESS:
      return {
        ...state,
        cashfreeLoading: false,
        cashfreeSettings: [...state.cashfreeSettings, action.payload],
      };

    case PAYMENT_ACTION_TYPES.GET_CASHFREE_SETTINGS_SUCCESS:
      return {
        ...state,
        cashfreeLoading: false,
        cashfreeSettings: action.payload,
      };

    case PAYMENT_ACTION_TYPES.UPDATE_CASHFREE_SETTING_SUCCESS:
      return {
        ...state,
        cashfreeLoading: false,
        cashfreeSettings: state.cashfreeSettings.map(setting =>
          setting.id === action.payload.id ? action.payload : setting
        ),
      };

    case PAYMENT_ACTION_TYPES.CREATE_CASHFREE_SETTING_FAIL:
    case PAYMENT_ACTION_TYPES.GET_CASHFREE_SETTINGS_FAIL:
    case PAYMENT_ACTION_TYPES.UPDATE_CASHFREE_SETTING_FAIL:
      return {
        ...state,
        cashfreeLoading: false,
        cashfreeError: action.payload,
      };

    // ==================== CASHFREE PAYOUT CASES ====================
    case PAYMENT_ACTION_TYPES.CREATE_CASHFREE_PAYOUT_SETTING_REQUEST:
    case PAYMENT_ACTION_TYPES.GET_CASHFREE_PAYOUT_SETTINGS_REQUEST:
    case PAYMENT_ACTION_TYPES.UPDATE_CASHFREE_PAYOUT_SETTING_REQUEST:
      return {
        ...state,
        cashfreePayoutLoading: true,
        cashfreePayoutError: null,
      };

    case PAYMENT_ACTION_TYPES.CREATE_CASHFREE_PAYOUT_SETTING_SUCCESS:
      return {
        ...state,
        cashfreePayoutLoading: false,
        cashfreePayoutSettings: [...state.cashfreePayoutSettings, action.payload],
      };

    case PAYMENT_ACTION_TYPES.GET_CASHFREE_PAYOUT_SETTINGS_SUCCESS:
      return {
        ...state,
        cashfreePayoutLoading: false,
        cashfreePayoutSettings: action.payload,
      };

    case PAYMENT_ACTION_TYPES.UPDATE_CASHFREE_PAYOUT_SETTING_SUCCESS:
      return {
        ...state,
        cashfreePayoutLoading: false,
        cashfreePayoutSettings: state.cashfreePayoutSettings.map(setting =>
          setting.id === action.payload.id ? action.payload : setting
        ),
      };

    case PAYMENT_ACTION_TYPES.CREATE_CASHFREE_PAYOUT_SETTING_FAIL:
    case PAYMENT_ACTION_TYPES.GET_CASHFREE_PAYOUT_SETTINGS_FAIL:
    case PAYMENT_ACTION_TYPES.UPDATE_CASHFREE_PAYOUT_SETTING_FAIL:
      return {
        ...state,
        cashfreePayoutLoading: false,
        cashfreePayoutError: action.payload,
      };

    // ==================== RAZORPAY PAYOUT CASES ====================
    case PAYMENT_ACTION_TYPES.CREATE_RAZORPAY_PAYOUT_SETTING_REQUEST:
    case PAYMENT_ACTION_TYPES.GET_RAZORPAY_PAYOUT_SETTINGS_REQUEST:
    case PAYMENT_ACTION_TYPES.UPDATE_RAZORPAY_PAYOUT_SETTING_REQUEST:
      return {
        ...state,
        razorpayPayoutLoading: true,
        razorpayPayoutError: null,
      };

    case PAYMENT_ACTION_TYPES.CREATE_RAZORPAY_PAYOUT_SETTING_SUCCESS:
      return {
        ...state,
        razorpayPayoutLoading: false,
        razorpayPayoutSettings: [...state.razorpayPayoutSettings, action.payload],
      };

    case PAYMENT_ACTION_TYPES.GET_RAZORPAY_PAYOUT_SETTINGS_SUCCESS:
      return {
        ...state,
        razorpayPayoutLoading: false,
        razorpayPayoutSettings: action.payload,
      };

    case PAYMENT_ACTION_TYPES.UPDATE_RAZORPAY_PAYOUT_SETTING_SUCCESS:
      return {
        ...state,
        razorpayPayoutLoading: false,
        razorpayPayoutSettings: state.razorpayPayoutSettings.map(setting =>
          setting.id === action.payload.id ? action.payload : setting
        ),
      };

    case PAYMENT_ACTION_TYPES.CREATE_RAZORPAY_PAYOUT_SETTING_FAIL:
    case PAYMENT_ACTION_TYPES.GET_RAZORPAY_PAYOUT_SETTINGS_FAIL:
    case PAYMENT_ACTION_TYPES.UPDATE_RAZORPAY_PAYOUT_SETTING_FAIL:
      return {
        ...state,
        razorpayPayoutLoading: false,
        razorpayPayoutError: action.payload,
      };

    // ==================== RESET STATE ====================
    case PAYMENT_ACTION_TYPES.RESET_PAYMENT_STATE:
      return initialState;

    default:
      return state;
  }
};

export default paymentReducer;